import base from '../base'

export default {
  queryUrl:`${base.url}/cloud/messageTemplate/logList`,
  sendFake:`${base.url}/cloud/messageTemplate/sendFake`,
  getTemplateCode:`${base.url}/cloud/messageTemplate/getTemplateCode`,
  emailCodeList:`${base.url}/cloud/verifyCodeSetting/list`,
  emailCodeSave:`${base.url}/cloud/verifyCodeSetting/save`,
  emailCodeEdit:`${base.url}/cloud/verifyCodeSetting/edit`,
  emailCodeDel:`${base.url}/cloud/verifyCodeSetting/del`,
  sendEmailCodeFake:`${base.url}/cloud/messageTemplate/sendEmailCodeFake`,
  logEmailCodeList:`${base.url}/cloud/messageTemplate/logEmailCodeList`,
  export:`${base.url}/cloud/messageTemplate/export`,
  emailExport:`${base.url}/cloud/messageTemplate/emailExport`,
}
